"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Party = void 0;
const DeferredAction_1 = require("../../deferredActions/DeferredAction");
const CardName_1 = require("../../CardName");
class Party {
    constructor() {
        this.partyLeader = undefined;
        this.delegates = [];
    }
    sendDelegate(playerId, game) {
        this.delegates.push(playerId);
        this.checkPartyLeader(playerId, game);
    }
    removeDelegate(playerId, game) {
        this.delegates.splice(this.delegates.indexOf(playerId), 1);
        this.checkPartyLeader(playerId, game);
    }
    checkPartyLeader(newPlayer, game) {
        const currentPartyLeader = this.partyLeader;
        if (currentPartyLeader !== undefined) {
            if (game) {
                const sortedPlayers = [...this.getPresentPlayers()].sort((p1, p2) => this.getDelegates(p2) - this.getDelegates(p1));
                const max = this.getDelegates(sortedPlayers[0]);
                if (this.getDelegates(currentPartyLeader) !== max) {
                    let currentIndex = 0;
                    if (this.partyLeader === 'NEUTRAL') {
                        currentIndex = game.getPlayers().indexOf(game.getPlayerById(game.activePlayer));
                    }
                    else {
                        currentIndex = game.getPlayers().indexOf(game.getPlayerById(currentPartyLeader));
                    }
                    let playersToCheck = [];
                    if (game.getPlayers().length === 1 || currentIndex === 0) {
                        playersToCheck = game.getPlayers();
                    }
                    else if (currentIndex === game.getPlayers().length - 1) {
                        playersToCheck = game.getPlayers().slice(0, currentIndex);
                        playersToCheck.unshift(game.getPlayers()[currentIndex]);
                    }
                    else {
                        const left = game.getPlayers().slice(0, currentIndex);
                        const right = game.getPlayers().slice(currentIndex);
                        playersToCheck = right.concat(left);
                    }
                    playersToCheck.push('NEUTRAL');
                    playersToCheck.some((nextPlayer) => {
                        let nextPlayerId = '';
                        if (nextPlayer === 'NEUTRAL') {
                            nextPlayerId = 'NEUTRAL';
                        }
                        else {
                            nextPlayerId = nextPlayer.id;
                        }
                        if (this.getDelegates(nextPlayerId) === max) {
                            this.partyLeader = nextPlayerId;
                            if (nextPlayer !== 'NEUTRAL') {
                                game.defer(new DeferredAction_1.DeferredAction(nextPlayer, () => {
                                    game.log('${0} is the new ${1} party leader', (b) => b.player(nextPlayer).string(this.name));
                                    return undefined;
                                }));
                            }
                            return true;
                        }
                        return false;
                    });
                }
            }
        }
        else {
            this.partyLeader = newPlayer;
        }
        if (this.partyLeader === newPlayer && newPlayer !== "NEUTRAL") {
            const player = game.getPlayerById(newPlayer);
            if (player.cardIsInEffect(CardName_1.CardName.CORRIDORS_OF_POWER)) {
                player.drawCard(1);
            }
        }
    }
    getPresentPlayers() {
        return Array.from(new Set(this.delegates));
    }
    getDelegates(player) {
        const delegates = this.delegates.filter((p) => p === player).length;
        return delegates;
    }
}
exports.Party = Party;
//# sourceMappingURL=Party.js.map